import * as React from 'react';
import { FilterProps } from '../filters';
import { Op } from '../../../enums/Op';
import { ReferenceFilter } from '../ReferenceFilter/referenceFilter';
import { DateFilter } from '../DateFilter/dateFilter';
import { View } from '../../../types/View';
import './auditFilter.scss';
import { parseCondition } from '../../../utils';

const RefOpts = [Op.refIds, Op.notRefIds, Op.isEmpty, Op.isNotEmpty];
const DateOpts = [
  Op.equals,
  Op.greaterThan,
  Op.lessThan,
  Op.between,
  Op.relative
];

const isRefOp = (op: any) => RefOpts.includes(op);

const getFiltersExcludeOpts = (
  rawfilters: View.FiltersField[],
  field: string,
  opts: string[]
) => {
  let filter: View.FiltersField;
  const filters: View.FiltersField[] = rawfilters?.map(f => {
    if (f.field == field) {
      filter = { ...f };
      if (!f.conditions?.length) return filter;
      filter.conditions = [
        Object.entries(f.conditions[0]).reduce((r, [key, value]) => {
          if (!opts.includes(key)) {
            r[key] = value;
          }
          return r;
        }, {})
      ];
      return filter;
    }
    return f;
  });
  return { filters, filter };
};

export const AuditFilter = (props: FilterProps) => {
  const { filter, field, filters, setFilter } = props;
  const { filters: refFilters, filter: refFilter } = getFiltersExcludeOpts(
    filters,
    filter.field,
    DateOpts
  );
  const { filters: dateFilters, filter: dateFilter } = getFiltersExcludeOpts(
    filters,
    filter.field,
    RefOpts
  );
  const { op } = parseCondition(refFilter.conditions, null);

  const setFilter_ =
    (otherConditions: View.FilterCondition[]) => (f: View.FiltersField) => {
      const conditions = [
        Object.entries(f.conditions[0]).reduce(
          (cs, [key, val]) => {
            if (!cs || key == Op.isEmpty) return { [key]: val };
            if (isRefOp(key)) return { [key]: val, ...cs };
            cs[key] = val;
            return cs;
          },
          otherConditions ? otherConditions[0] : {}
        )
      ];
      return setFilter({ ...f, conditions });
    };

  return (
    <div className="audit-filter">
      <ReferenceFilter
        {...props}
        opts={RefOpts}
        inlineMenu={false}
        field={{ ...field, name: field.name.replace('By/On', 'By') }}
        filter={refFilter}
        filters={refFilters}
        setFilter={setFilter_(dateFilter.conditions)}
      />
      {op != Op.isEmpty && (
        <DateFilter
          {...props}
          opts={DateOpts}
          field={{ ...field, name: field.name.replace('By/On', 'On') }}
          filter={dateFilter}
          filters={dateFilters}
          setFilter={setFilter_(refFilter.conditions)}
        />
      )}
    </div>
  );
};
